import { EWorksheetStatus, getEWorksheetStatusList } from '@if/core/types'
import { formatDate } from '@if/core/utils'
import * as yup from '@if/core/yup'
import {
  IFinanceBaseWorksheet,
  IFinanceBaseWorksheetDecisionDTOSchema,
  IFinanceBaseWorksheetRevision,
  IFinanceBaseWorksheetSchema,
} from './IFinanceBaseWorksheetSchema'

const b2cWorksheetSchema = IFinanceBaseWorksheetSchema

export const B2cWorksheetSchema = yup.object({ ...b2cWorksheetSchema.fields })

export type B2cWorksheet = IFinanceBaseWorksheet

export type B2cWorksheetRevision = IFinanceBaseWorksheetRevision

export type B2cWorksheetDecisionDTO = yup.InferType<typeof IFinanceBaseWorksheetDecisionDTOSchema>

export const EditB2cWorksheetDtoSchema = yup.object({
  status: yup.mixed<EWorksheetStatus>().required().default(EWorksheetStatus.Draft).oneOf(getEWorksheetStatusList()),
  amountRequested: yup.double().positive(),
  deliveryOn: yup.string().default('').required(),
  firstPaymentOn: yup.string().dateOnly().default(formatDate(new Date())).nullable().required(),
  includeInsurance: yup.boolean().default(false),
  paymentFrequency: yup.string().default('').required(),
  term: yup.integer().min(6).required(),
  paymentPlanId: yup.string().required(),
  creditApplicationId: yup.string().nullable(),
  versionTag: yup.string(),
})
export type EditB2cWorksheetDto = yup.InferType<typeof EditB2cWorksheetDtoSchema>
